import React, { useContext } from 'react';
import { Body, FlexColumnCenter, Header2 } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import styled from 'styled-components';
import { HELP_DESK_STATUSES } from '@ubeya/shared/constants/helpDesk';

const Wrapper = styled(FlexColumnCenter)`
  flex: 1;
  color: ${({ theme }) => theme.colors.grey4};
`;

const Text = styled(Body)`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
`;

const Header = styled(Header2)`
  margin-bottom: 12px;
  font-weight: 600;
`;

const EMPTY_STATE_BY_STATUS = {
  [HELP_DESK_STATUSES.CLOSED]: 'help_desk_no_closed_tickets',
  [HELP_DESK_STATUSES.SNOOZED]: 'help_desk_no_snoozed_tickets'
};

const HelpDeskListEmpty = ({ status }) => {
  const { t } = useContext(ConfigContext);

  if (status === HELP_DESK_STATUSES.OPEN) {
    return (
      <Wrapper>
        <Header>{t('help_desk_no_open_tickets')}</Header>
        <Text>{t('help_desk_all_clear')}</Text>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Text>{t(EMPTY_STATE_BY_STATUS[status])}</Text>
    </Wrapper>
  );
};

export default HelpDeskListEmpty;
